//@ts-nocheck
import { IInputStatus } from '../../../../interface/progress.interface';

const checkAllInputsStatusHandler = (stepsProgress: any, values: Record<string, string>) => {
  let newStepsProgress = { ...stepsProgress };

  // Итерируемся по каждому шагу
  Object.entries(newStepsProgress).forEach(([stepNumber, stepData]) => {
    // Итерируемся по каждому input шага
    Object.entries(stepData.inputs).forEach(([name, inputData]) => {
      const value = values[name];
      const inputStatus = inputData.status;

      // Обновляем статус input в зависимости от его текущего статуса и значения
      if (inputStatus !== IInputStatus.disabled && inputStatus !== IInputStatus.dispensable) {
        if (value !== null && value !== "") {
          if (inputStatus !== IInputStatus.error && inputStatus !== IInputStatus.apiError) {
            inputData.status = IInputStatus.success;
          }
        } else if (value === "") {
          inputData.status = IInputStatus.none;
        }
      }
    });
  });

  return newStepsProgress
}

export default checkAllInputsStatusHandler

const values = {
  phone: '60000000',
  firstname: 'asd',
  lastname: 'qwert',
  
}
const stepsProgress = {
  inputs: [

  ]
}